
export default class DtoPiezometerKeyFigure{
	constructor(obj) {
		this.piezometerId= obj.stationid
		this.nbmeasure= obj.nbmeasure
		this.lastdate= obj.lastdate
		this.firstdate= obj.firstdate
		this.lastvalue= obj.lastvalue
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoPiezometerKeyFigure.js